// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"c2c81ad6","72":"23f846e8","519":"566fb667","587":"3f369d66","799":"c2c81ad6","951":"c2c81ad6"}[chunkId] + ".chunk.css";
};